import { render, staticRenderFns } from "./EditCustomHighlights.vue?vue&type=template&id=6d3df81c&scoped=true&"
import script from "./EditCustomHighlights.vue?vue&type=script&lang=ts&"
export * from "./EditCustomHighlights.vue?vue&type=script&lang=ts&"
import style0 from "./EditCustomHighlights.vue?vue&type=style&index=0&id=6d3df81c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d3df81c",
  null
  
)

export default component.exports